import { DriveWheel } from "../data/bruktbilsalgBackend/types/car.types";

export const translateDriveWheel = (driveWheel: DriveWheel) => {
  switch (driveWheel) {
    case "FourWheelDrive":
      return "Firehjulsdrift";
    case "FrontWheelDrive":
      return "Fronthjulsdrift";
    case "RearWheelDrive":
      return "Bakhjulsdrift";
  }
};
